(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7237],{

/***/ 67237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ brands_Brands; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/profileSlice.js
var profileSlice = __webpack_require__(82025);
// EXTERNAL MODULE: ./containers/index.js + 35 modules
var containers = __webpack_require__(44420);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
;// CONCATENATED MODULE: ./containers/brands/constants.js
// eslint-disable-next-line import/prefer-default-export
var allFilterBrands = [{
  name: 'ТОП-БРЕНДЫ',
  key: 'top'
}, {
  name: 'A'
}, {
  name: 'B'
}, {
  name: 'C'
}, {
  name: 'D'
}, {
  name: 'E'
}, {
  name: 'F'
}, {
  name: 'G'
}, {
  name: 'H'
}, {
  name: 'I'
}, {
  name: 'J'
}, {
  name: 'K'
}, {
  name: 'L'
}, {
  name: 'M'
}, {
  name: 'N'
}, {
  name: 'O'
}, {
  name: 'P'
}, {
  name: 'Q'
}, {
  name: 'R'
}, {
  name: 'S'
}, {
  name: 'T'
}, {
  name: 'U'
}, {
  name: 'V'
}, {
  name: 'W'
}, {
  name: 'X'
}, {
  name: 'Y'
}, {
  name: 'Z'
}, {
  name: '0-9',
  key: 'number'
}, {
  name: 'А-Я',
  key: 'ru'
}, {
  name: 'ВСЕ',
  key: 'all'
}];
// EXTERNAL MODULE: ./containers/brands/Brands.module.scss
var Brands_module = __webpack_require__(30887);
var Brands_module_default = /*#__PURE__*/__webpack_require__.n(Brands_module);
// EXTERNAL MODULE: ./components/index.js + 177 modules
var components = __webpack_require__(74030);
// EXTERNAL MODULE: ./utils/index.js + 3 modules
var utils = __webpack_require__(70214);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./containers/brands/Brands.js













var Brands = function Brands(_ref) {
  var _seoData$h;

  var seoData = _ref.seoData;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  var brands = (0,es/* useSelector */.v9)(profileSlice/* getBrands */.vp) || [];
  var topBrands = (0,react.useMemo)(function () {
    return brands.filter(function (_ref2) {
      var is_premium = _ref2.is_premium;
      return is_premium;
    });
  }, [brands]);

  var _useState = (0,react.useState)(allFilterBrands[0].name),
      activeLink = _useState[0],
      setActiveLink = _useState[1];

  var _useState2 = (0,react.useState)(topBrands),
      currentBrands = _useState2[0],
      setCurrentBrands = _useState2[1];

  var _useState3 = (0,react.useState)(true),
      isTopBrands = _useState3[0],
      setIsTopBrands = _useState3[1];

  var ruBrands = (0,react.useMemo)(function () {
    return brands.filter(function (_ref3) {
      var name = _ref3.name;
      return name[0].toUpperCase().match(/^[А-ЯЁ]$/);
    });
  }, [brands]);
  var numberBrands = (0,react.useMemo)(function () {
    return brands.filter(function (_ref4) {
      var name = _ref4.name;
      return name[0].match(/^[0-9]$/);
    });
  }, [brands]);
  (0,react.useEffect)(function () {
    setCurrentBrands(topBrands);
  }, [topBrands]);
  var isDisabledEmptyLetter = (0,react.useCallback)(function (brandName) {
    return brands.some(function (_ref5) {
      var name = _ref5.name;
      return name[0].toLowerCase() === brandName.toLowerCase();
    });
  }, [brands]);
  var isDisabledItemBrand = (0,react.useCallback)(function (brandName, key) {
    return !key && !isDisabledEmptyLetter(brandName) || key === 'ru' && !ruBrands.length || key === 'number' && !numberBrands.length;
  }, [isDisabledEmptyLetter, ruBrands, numberBrands]);
  var handleClick = (0,react.useCallback)(function (brandName, key) {
    if (isDisabledItemBrand(brandName, key)) {
      return;
    }

    setActiveLink(brandName);
    setIsTopBrands(false);

    switch (key) {
      case 'all':
        setCurrentBrands(brands);
        break;

      case 'number':
        setCurrentBrands(numberBrands);
        break;

      case 'ru':
        setCurrentBrands(ruBrands);
        break;

      case 'top':
        setIsTopBrands(true);
        setCurrentBrands(topBrands);
        break;

      default:
        setCurrentBrands(brands.filter(function (_ref6) {
          var _name$;

          var name = _ref6.name;
          return ((_name$ = name[0]) === null || _name$ === void 0 ? void 0 : _name$.toLowerCase()) === (brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase());
        }));
        break;
    }
  }, [brands, setActiveLink, setCurrentBrands, setIsTopBrands, isDisabledItemBrand, numberBrands, ruBrands, topBrands]);
  var breadcrumbs = [{
    name: 'Бренды',
    slug: 'brands'
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers/* Container */.W2, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Brands_module_default()).breadCrumbs,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* BreadCrumbs */.bu, {
          breadcrumbs: breadcrumbs
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Brands_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Title */.Dx, {
        component: "h1",
        className: (Brands_module_default()).title,
        children: (_seoData$h = seoData === null || seoData === void 0 ? void 0 : seoData.h1) !== null && _seoData$h !== void 0 ? _seoData$h : 'Бренды'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Brands_module_default()).filter,
        children: allFilterBrands.map(function (_ref7) {
          var name = _ref7.name,
              key = _ref7.key;
          return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            type: "button",
            onClick: function onClick() {
              return handleClick(name, key);
            },
            className: (0,clsx_m/* default */.Z)((Brands_module_default()).filterItem, activeLink === name && (Brands_module_default()).active, isDisabledItemBrand(name, key) && (Brands_module_default()).disable),
            children: name
          }, name);
        })
      }), isTopBrands ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Brands_module_default()).topBrands,
        children: currentBrands.map(function (_ref8) {
          var name = _ref8.name,
              url = _ref8.url,
              image = _ref8.image;

          if (image !== null && image !== void 0 && image.x2) {
            return url ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: (Brands_module_default()).topBrandsItem,
              href: url,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: (Brands_module_default()).img,
                src: image === null || image === void 0 ? void 0 : image.x2,
                alt: name
              })
            }, url) : null;
          }

          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (Brands_module_default()).topBrandsItem,
            children: name
          }, name);
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Brands_module_default()).brands,
        children: currentBrands.map(function (_ref9) {
          var name = _ref9.name,
              url = _ref9.url;
          return url ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: (Brands_module_default()).brandItem,
            href: url,
            children: name
          }, url) : null;
        })
      })]
    })]
  });
};

/* harmony default export */ var brands_Brands = (Brands);
;// CONCATENATED MODULE: ./containers/brands/index.js


/***/ }),

/***/ 30887:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Brands_container__Qc3Pu","title":"Brands_title__yS8VQ","filter":"Brands_filter__svQVo","filterItem":"Brands_filterItem__jUH6T","disable":"Brands_disable__K7NRa","active":"Brands_active__AM_zq","brands":"Brands_brands__ijDsO","brandItem":"Brands_brandItem__MGfi5","topBrands":"Brands_topBrands__EI_zb","topBrandsItem":"Brands_topBrandsItem__j2CKp","breadCrumbs":"Brands_breadCrumbs__oA2y8","img":"Brands_img__Sfe3D","load":"Brands_load__OojsI"};

/***/ })

}]);